"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnapprovedLoanApplicationReasonErrorCode = exports.ReUnderwriteAANScreen = void 0;
var ReUnderwriteAANScreen;
(function (ReUnderwriteAANScreen) {
    ReUnderwriteAANScreen["cliAndAprReductionAndBalanceSweep"] = "cliAndAprReductionAndBalanceSweep";
    ReUnderwriteAANScreen["cli"] = "cli";
})(ReUnderwriteAANScreen || (exports.ReUnderwriteAANScreen = ReUnderwriteAANScreen = {}));
var UnapprovedLoanApplicationReasonErrorCode;
(function (UnapprovedLoanApplicationReasonErrorCode) {
    UnapprovedLoanApplicationReasonErrorCode["noReasonCodes"] = "noReasonCodes";
})(UnapprovedLoanApplicationReasonErrorCode || (exports.UnapprovedLoanApplicationReasonErrorCode = UnapprovedLoanApplicationReasonErrorCode = {}));
